import { Dispatch, FC, SetStateAction, useRef } from 'react'
import { Box, Button, Stack, Tooltip } from '@mui/material'
import Search from '../../../shared/Search'
import AddIcon from '@mui/icons-material/Add'
import FileUploadIcon from '@mui/icons-material/FileUpload'
import RefreshIcon from '@mui/icons-material/Refresh'

import styles from './styles.module.scss'

interface IProps {
  onSearch: (search: string) => void
  onRefresh: () => void
  onImport: (file: File) => void
  setIsOpen: Dispatch<SetStateAction<boolean>>
}

const DashboardToolbar: FC<IProps> = ({ onSearch, onRefresh, onImport, setIsOpen }) => {
  const fileInputRef = useRef<HTMLInputElement>(null)

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file) {
      onImport(file)
    }
    event.target.value = ''
  }

  return (
    <Box className={styles.toolbar}>
      <Search
        onSearch={onSearch}
        sx={{
          width: '300px',
        }}
      />
      <Stack direction="row" gap={1}>
        <Button
          data-testid="addButton"
          id="openPlaybookCreateModal"
          className={styles.createBtn}
          onClick={() => setIsOpen(true)}
          startIcon={<AddIcon />}
          variant="contained"
        >
          Create Playbook
        </Button>

        <Tooltip title="Upload YAML" disableInteractive>
          <Button
            data-testid="uploadButton"
            onClick={() => fileInputRef.current?.click()}
            startIcon={<FileUploadIcon />}
            variant="contained"
            sx={{
              minWidth: '40px',
              '& .MuiButton-icon': {
                m: 0,
              },
            }}
          />
        </Tooltip>
        <input
          type="file"
          ref={fileInputRef}
          accept=".yaml,.yml"
          style={{ display: 'none' }}
          onChange={handleFileChange}
        />

        <Tooltip title="Refresh list" disableInteractive>
          <Button
            data-testid="refreshButton"
            onClick={onRefresh}
            startIcon={<RefreshIcon />}
            variant="contained"
            sx={{
              minWidth: '40px',
              '& .MuiButton-icon': {
                m: 0,
              },
            }}
          />
        </Tooltip>
      </Stack>
    </Box>
  )
}

export default DashboardToolbar
